import { useState } from 'react'

import { Card } from 'antd'
import {
  faAt,
  faCity,
  faComment,
  faGlobe,
  faIdBadge,
  faMerge,
  faSave,
  faStethoscope
} from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconLabel from '../../../Components/icons/IconLabel'
import { Properties } from '../../../utils/entities'
import InstitutionsList from '../../../Components/shared/Lists/InstitutionsList'
import IconButton from '../../../Components/antd/Buttons/IconButton'
import { isObject } from '../../../utils'

const { ACRONYM, ADDRESS, CITY, COUNTRY, GLOBAL_MESSAGE, NAME, SECTOR, ZIPCODE, EMAIL } = Properties

const InstitutionValidator = ({ institution, onValidate, onMerge }) => {
  const t = useSelector(selectTranslate)

  const [selectedInstitution, setSelectedInstitution] = useState(null)

  return (
    <div className='h-100 w-100 flex-row'>
      <div className='flex-column h-100 w-50 mr-8 jc-between'>
        <h3>{t('institution_validator.title')}</h3>
        <Card size='small' title={institution[NAME]}>
          <IconLabel icon={faIdBadge} text={institution[ACRONYM]} fontSize='small' />
          <IconLabel icon={faAt} text={institution[EMAIL]} fontSize='small' />
          <IconLabel icon={faCity} text={`${institution[ADDRESS]}, ${institution[ZIPCODE]}`} fontSize='small' />
          <IconLabel icon={faGlobe} text={`${institution[CITY]}, ${institution[COUNTRY]?.name ?? ''}`} fontSize='small' />
          {institution[GLOBAL_MESSAGE] && <IconLabel icon={faComment} text={institution[GLOBAL_MESSAGE]} fontSize='small' />}
          {isObject(institution[SECTOR]) && (<IconLabel icon={faStethoscope} text={institution[SECTOR].name} fontSize='small' />)}
        </Card>
        <IconButton
          className='mt-12'
          disabled={!!selectedInstitution}
          icon={faSave}
          text={t('common.validate')}
          type='primary'
          onClick={() => onValidate(institution)}
        />
      </div>
      <div className='flex-column h-100 w-50'>
        <h3>{t('institution_validator.description')}</h3>
        <InstitutionsList selected={selectedInstitution} onSelectedChange={setSelectedInstitution} />
        <IconButton
          className='mt-12'
          disabled={!selectedInstitution}
          icon={faMerge}
          text={t('intitution_validator.merge_button')}
          type='primary'
          onClick={() => onMerge({ id: selectedInstitution })}
        />
      </div>
    </div>
  )
}

export default InstitutionValidator
